import {
  CloudUploadOutlined,
  Delete,
  Visibility,
} from "@mui/icons-material";
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
  Tooltip,
  TextField, Box, Button, AccordionSummary, Accordion, AccordionDetails, CircularProgress, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody,
} from "@mui/material";
import Dropzone from "modules/Forms/components/dropzone.component";
import {
  AuthenticatedImageBackgroundDiv,
} from "modules/UI/components/AuthenticatedImage.component";
import Drawer from "modules/UI/components/Drawer.component";
import React, { useState, useEffect } from "react";
import { FileRejection, DropEvent } from "react-dropzone";
import { createBlobService } from "utils/factories";
import { useFetchPromoCategories } from "../../Admin/service/promoCategory.hook";
import { MediaFile, QualityAttachmentsTable } from "./QualityAttachmentsTable";

function fileToDataUrl(file: File) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
}

export type MediaManagerPropsType = {
  onUpload?: (files: File[], data?: any) => void;
  onDelete?: (mediaId: any) => void;
  onUploadFromUrl?: (link: string) => void;
  images?: any[];
  error?: any;
  readOnly?: boolean;
};

export type MediaManagerDrawerPropsType = MediaManagerPropsType & {
  open?: boolean;
  onClose?: () => void;
  promoCategoryId?: number;
  materialId?: number;
  qualityDocs?: MediaFile[];
  loadingQualityDocs?: boolean;
  deletingQualityDocs?: boolean;
  parentMediaFiles?: any[];
  parentQualityDocs?: MediaFile[];
  campaignState?: number;

  isChildPsl?: boolean;
  allowCpEditableMedia?: boolean;
};
export const MediaManager = ({
  onUpload,
  onUploadFromUrl,
  onDelete,
  images,
  error,
  readOnly,
}: MediaManagerPropsType) => {
  const [url, setUrl] = useState<string>("");
  
  return (
    <>
      {!readOnly && (
        <>
          {!!onUploadFromUrl && (
            <TextField
              type="url"
              placeholder="https://example.com/image.jpg"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              label="Upload from URL"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onUploadFromUrl(url);
                  setUrl("");
                }
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    disabled={
                      !/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
                        url
                      )
                    }
                    onClick={() => {
                      onUploadFromUrl(url);
                      setUrl("");
                    }}
                  >
                    <CloudUploadOutlined />
                  </IconButton>
                ),
              }}
            />
          )}
          <Dropzone
            error={error}
            multiple
            accept={{
              "image/png": [".png"],
              "image/jpeg": [".jpg", ".jpeg"],
              "application/pdf": [".pdf"],
            }}
            placeholder={"Drag and drop more media files here..."}
            onDrop={async function <T extends File>(
              acceptedFiles: T[],
              fileRejections: FileRejection[],
              event: DropEvent
            ): Promise<void> {
              !!onUpload && onUpload(acceptedFiles);
            }}
          />
        </>
      )}
      {/* <ImageList cols={3} rowHeight={164}>
        {images?.map((item) => (
          <ImageListItem key={item.fileId} sx={{ overflow: "hidden" }}>
            <AuthenticatedImageBackgroundDiv
              src={item.url}
              style={{
                width: 142,
                height: 165,
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                border: "1px solid #eee",
              }}
            />
            <ImageListItemBar
              actionIcon={
                <>
                  <Tooltip title="Preview">
                    <IconButton
                      sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                      onClick={() => {
                        createBlobService(item.url, "GET")().then((blob) => {
                          window.open(URL.createObjectURL(blob), "_blank");
                        });
                      }}
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                  {!readOnly && (
                    <Tooltip title="Remove">
                      <IconButton
                        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                        onClick={() => {
                          !!onDelete && onDelete(item.fileId);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              }
            />
          </ImageListItem>
        ))}
      </ImageList> */}
      <ImageList cols={3} rowHeight={164}>
        {(images || []).map((item, index) => {
          const isImage =
            item?.mimeType?.startsWith("image/") ||
            /\.(png|jpg|jpeg|gif|webp)$/i.test(item?.url || "");

          const isPdf =
            item?.mimeType === "application/pdf" ||
            /\.pdf(\?|$)/i.test(item?.url || "");

          return (
            <ImageListItem
              key={item?.fileId || index}
              sx={{ overflow: "hidden" }}
            >
              {/* Image Preview */}
              {isImage ? (
                <AuthenticatedImageBackgroundDiv
                  src={item.url}
                  style={{
                    width: 142,
                    height: 165,
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                    border: "1px solid #eee",
                  }}
                />
              ) : (
                /* PDF Preview */
                <Box
                  sx={{
                    width: 142,
                    height: 165,
                    border: "1px solid #eee",
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#fafafa",
                    p: 1,
                  }}
                >
                  <Box
                    sx={{
                      fontSize: 48,
                      lineHeight: 1,
                      color: "error.main",
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    PDF
                  </Box>

                  <Box
                    sx={{
                      fontSize: 11,
                      textAlign: "center",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {item?.originalFileName || "Document.pdf"}
                  </Box>
                </Box>
              )}

              <ImageListItemBar
                actionIcon={
                  <>
                    <Tooltip title="Preview">
                      <IconButton
                        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                        onClick={() => {
                          createBlobService(item.url, "GET")().then((blob) => {
                            const blobUrl = URL.createObjectURL(blob);
                            window.open(blobUrl, "_blank");
                          });
                        }}
                      >
                        <Visibility />
                      </IconButton>
                    </Tooltip>

                    {!readOnly && (
                      <Tooltip title="Remove">
                        <IconButton
                          sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                          onClick={() => {
                            onDelete?.(item.fileId);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                }
              />
            </ImageListItem>
          );
        })}
      </ImageList>
    </>
  );
};

export const MediaManagerDrawer = ({
  open,
  onClose,
  onUpload,
  onUploadFromUrl,
  onDelete,
  images,
  readOnly,
}: MediaManagerDrawerPropsType) => {
  return (
    <Drawer open={open} onClose={() => onClose()} title="Manage Multimedia">
      <MediaManager
        onUpload={onUpload}
        onUploadFromUrl={onUploadFromUrl}
        onDelete={onDelete}
        images={images}
        readOnly={readOnly}
      />
    </Drawer>
  );
};
export default MediaManagerDrawer;
export const PromoMediaManagerDrawer = ({
  open,
  onClose,
  onUpload,
  onUploadFromUrl,
  onDelete,
  images,
  readOnly,
  promoCategoryId,
  materialId,
  qualityDocs,
  loadingQualityDocs,
  deletingQualityDocs,
  parentMediaFiles,
  parentQualityDocs,
  campaignState,
  isChildPsl,
  allowCpEditableMedia,
}: MediaManagerDrawerPropsType) => {
  // Determine initial expanded accordion
  const parentProductPhotos = parentMediaFiles?.filter((m) => m.isQuality === false) || [];
  const hasProductPhotos = images && images.length > 0;
  const hasParentProductPhotos = parentProductPhotos.length > 0;
  const initialExpanded = !hasProductPhotos && hasParentProductPhotos ? "0" : "1";

  const [expanded, setExpanded] = useState<string | false>(initialExpanded);
  // const blockedStatuses = [1];

  const isChildMediaReadOnly =
    readOnly ||
    (isChildPsl && !allowCpEditableMedia);

  useEffect(() => {
    if (open) {
      const newExpanded = !hasProductPhotos && hasParentProductPhotos ? "0" : "1";
      setExpanded(newExpanded);
    }
  }, [open, hasProductPhotos, hasParentProductPhotos]);

  const { promoCategories, isLoadingCategories } = useFetchPromoCategories();
console.log("jangry:",  {
  isChildPsl,
  parentMediaFiles,
  parentQualityDocs,
});
  return (
    <Drawer open={open} onClose={() => onClose()} title="Manage Mutimedia">
      {isChildPsl && (
      // {showChildSections && (
        <Accordion
          expanded={expanded === "0"}
          onChange={(e, isExpanded) => setExpanded(isExpanded ? "0" : false)}
        >
          <AccordionSummary
            sx={{ fontWeight: "bold", textTransform: "uppercase" }}
          >
            Parent Product Photos
          </AccordionSummary>
          <AccordionDetails>
            <MediaManager
              images={parentMediaFiles?.filter((m) => m.isQuality === false)}
              readOnly={true}
            />
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion
        expanded={expanded === "1"}
        onChange={(e, isExpanded) => setExpanded(isExpanded ? "1" : false)}
      >
        <AccordionSummary
          sx={{ fontWeight: "bold", textTransform: "uppercase" }}
        >
          {isChildPsl ? "Local Product Photos" : "Product Photos"}
        </AccordionSummary>
        <AccordionDetails>
          {/* <MediaManager
            onUpload={onUpload}
            onUploadFromUrl={onUploadFromUrl}
            onDelete={onDelete}
            images={images}
            readOnly={readOnly}
          /> */}
          <MediaManager
            onUpload={onUpload}
            onUploadFromUrl={onUploadFromUrl}
            onDelete={onDelete}
            images={images}
            readOnly={isChildMediaReadOnly}
          />
        </AccordionDetails>
      </Accordion>
      {isChildPsl && promoCategories[promoCategoryId]?.qualityControl && parentQualityDocs && parentQualityDocs.length > 0 && (
        <Accordion
          expanded={expanded === "3"}
          onChange={(e, isExpanded) =>
            setExpanded(isExpanded ? "3" : false)
          }
        >
          <AccordionSummary
            sx={{ fontWeight: "bold", textTransform: "uppercase" }}
          >
            Parent Quality Attachments
          </AccordionSummary>
          <AccordionDetails>
            <QualityAttachmentsTable
              readOnly={true}
              mediaFiles={parentQualityDocs}
              promoCategory={promoCategories[promoCategoryId]}
              onDelete={() => { }}
              deleting={false}
            />
          </AccordionDetails>
        </Accordion>
      )}
      {promoCategories[promoCategoryId]?.qualityControl && (
        <Accordion
          expanded={expanded === "4"}
          onChange={(e, isExpanded) =>
            setExpanded(isExpanded ? "4" : false)
          }
        >
          <AccordionSummary
            sx={{ fontWeight: "bold", textTransform: "uppercase" }}
          >
            {isChildPsl ? "Local Quality Attachments" : "Quality Attachments"}
          </AccordionSummary>
          <AccordionDetails>
            {promoCategories[promoCategoryId]?.documents?.map(
              (attachment) => {
                return (
                  <Box
                    my={2}
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    {attachment.name}{" "}
                    <Button
                      component="label"
                      size="small"
                      variant="contained"
                      color="primary"
                      startIcon={loadingQualityDocs ? <CircularProgress size={18} /> : <CloudUploadOutlined />}
                      //disabled={loadingQualityDocs || readOnly}
                      disabled={loadingQualityDocs || isChildMediaReadOnly}
                    >
                      <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          onUpload([e.target.files[0]], {
                            document: attachment.id,
                            materialId: materialId,
                            isQuality: true,
                          })

                        }}
                      />
                      Upload
                    </Button>
                  </Box>
                );
              }
            )}
            <QualityAttachmentsTable
              //  readOnly={readOnly}
              readOnly={isChildMediaReadOnly}
              mediaFiles={qualityDocs}
              promoCategory={promoCategories[promoCategoryId]}
              onDelete={fileId => onDelete(fileId)}
              deleting={deletingQualityDocs}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </Drawer>
  );
};


